
interface idTracker {
  [key: string]: number;
}

const uniqueID = ((index: string, separator = '_') => {
  const idTracker: idTracker = {};
  if (index in idTracker) {
    idTracker[index] += 1;
  } else {
    idTracker[index] = 0;
  }
  return `${index}${separator}${idTracker[index]}`;
});

export default uniqueID;